export default "__VITE_ASSET__ovNIrE4i__"